import { Link } from "react-router-dom";
import { scoops } from "@/mocks/scoops";
import ScoopCard from "@/components/base/ScoopCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FeaturedScoop() {
  const featured = scoops[0];

  return (
    <section className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16" aria-labelledby="featured-heading">
      <div id="featured-heading">
        <SectionHeading
          eyebrow="重点档案"
          title="本期最值得细看的一条求证"
          desc="从九段连续实拍到内部单据，我们把每一条材料单独列出并标注核验状态，你可以沿着来源链自行复核。"
          action={{ label: "查看全部档案", to: "/scoops" }}
        />
      </div>
      <ScoopCard scoop={featured} variant="feature" />

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {[
          { icon: "ri-file-list-3-line", label: "登记材料", value: `${featured.evidence.length} 份` },
          { icon: "ri-links-line", label: "独立来源", value: `${featured.sources} 个` },
          { icon: "ri-refresh-line", label: "最近更新", value: featured.updated.slice(5) },
        ].map((item) => (
          <div key={item.label} className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className={`${item.icon} text-[18px]`} aria-hidden="true"></i>
            </span>
            <div>
              <p className="font-label text-[11px] text-foreground-500">{item.label}</p>
              <p className="font-heading text-sm font-bold text-foreground-950">{item.value}</p>
            </div>
          </div>
        ))}
      </div>

      <Link
        to={`/scoop/${featured.id}`}
        className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
      >
        阅读完整求证过程
        <i className="ri-arrow-right-line" aria-hidden="true"></i>
      </Link>
    </section>
  );
}